import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import { SupportedMapLayers } from './enums';
import { AbstractMapLayerBase } from './MapLayerBase';
import { withDateProcessors } from './DateTimeUtility';
export const CLOUDY_NDVI_PERCENTAGE = 50;
const ThresholdsModel = types.model({
  performance: types.model({
    high: types.maybeNull(types.number),
    low: types.maybeNull(types.number)
  })
});
export const VI = withDateProcessors(AbstractMapLayerBase.named('VI').props({
  uri: types.maybeNull(types.string),
  thresholds: types.optional(ThresholdsModel, {
    performance: {
      low: null,
      high: null
    }
  }),
  cloudy: types.boolean,
  mean: types.maybeNull(types.number),
  band: types.maybeNull(types.number)
}));
export type IVI = Instance<typeof VI>;
export type IVISnapshotIn = SnapshotIn<typeof VI>;